import { Grid, Box } from '@mui/material';
import RegisterFooter from 'components/RegisterFooter';
import logo from '../../images/Familiprix_logo.svg';
import Language from '../Language';
import { Outlet } from 'react-router';
import { shadows } from 'lightTheme';

const background = (theme: { palette: { background: { main: string } } }) => theme.palette.background.main;
const backgroundDark = (theme: { palette: { background: { dark: string } } }) => theme.palette.background.dark;
const backgroundLight = (theme: { palette: { background: { light: string } } }) => theme.palette.background.light;

const FamiliprixPageBase = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexFlow: 'column' }}>
      <Box sx={{ flex: '0 1 auto' }}>
        <Grid item xs={12} bgcolor={backgroundLight} boxShadow={shadows.familiprixHeader}>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ paddingRight: '16px' }}>
              <Box
                sx={{ width: '75%', top: '5px', margin: '10px', position: 'relative' }}
                component="img"
                src={logo}
                alt="Familiprix"></Box>
            </Box>
            <Box sx={{ margin: '15px', marginLeft: 'auto' }}>
              <Language variant="menuPrimary" />
            </Box>
          </Box>
        </Grid>
      </Box>
      <Box sx={{ flex: '1 1 auto' }}>
        <Grid item xs={12} bgcolor={background} height="100%">
          <Outlet />
        </Grid>
      </Box>
      <Box sx={{ flex: '0 1 149px', zIndex: 1 }}>
        <Grid item xs={12} bgcolor={backgroundDark}>
          <RegisterFooter />
        </Grid>
      </Box>
    </Box>
  );
};

export default FamiliprixPageBase;
